import React from 'react'
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAdminContext } from '../../context/adminContext';

const Header = () => {
  // const [adminInfo,setAdminInfo] = useState();
  const data = useLocation();
  const allPaths = data.pathname.split('/').filter(Boolean);
  const token = localStorage.getItem("token");
  const { adminDetail } = useAdminContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const handlePartners = (e) => {
    let params = { type: e.target.value }
    if (e.target.value === "driver") params["tab"] = "driver"
    if (e.target.value === "package") params["tab"] = "category"
    if (e.target.value === "rentals") params["tab"] = "vendor"
    if (e.target.value === "restaurant") params["tab"] = "restaurant"
    if (e.target.value === "salesAgent") params["tab"] = "salesAgent"
    if (e.target.value === "busOperator") params["tab"] = "busOperator"
    if (e.target.value === "fleetOwner") params["tab"] = "fleetOwner"
    setSearchParams(params)
  }

  const formatTitle = (str = "") =>
    str
      .split("-")
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");


  let pageTitle = "";
  
  if (adminDetail?.role === "webAdmin") {
    pageTitle = "Terms And Conditions";
  }
  else if (allPaths[0] === "dashboard") {

    if (allPaths.length === 1) {
      pageTitle = "Dashboard";
    } else {
      pageTitle = formatTitle(allPaths[1]);
    }

  } else {
    pageTitle = formatTitle(allPaths[0]);
  }

  return (
    <>{token && <>
      <div className="main-content  overflow-y-a">
        <div className="header">
          <div className="container-fluid">
            {/* Body */}
            <div className="header-body">
              <div className=" d-flex justify-content-between align-items-end">
                <div className="">
                  {/* Pretitle */}
                  <h6 className="header-pretitle">Overview</h6>
                  {/* Title */}
                  <h1 className="header-title">
                    {pageTitle}
                  </h1>
                </div>
                <div className="" style={{ width: "15%" }}>
                  {adminDetail?.role !== "admin1" && allPaths?.join("") === "partners" && <select className="form-select w-100" aria-label="" value={searchParams.get("type")} onChange={handlePartners} >
                    <option value="all">All</option>
                    <option value="driver">Driver</option>
                    <option value="package">Package</option>
                    <option value="rentals">Car Rental</option>
                    <option value="restaurant">Restaurant</option>
                    <option value="salesAgent">Sales Agent</option>
                    <option value="busOperator">Bus Operator</option>
                    <option value="fleetOwner">Fleet Owner</option>
                  </select>}
                  {/* Button */}
                  {/* <div className="dropdown">
                   
                    <button
                      className="btn btn-second dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={`${
                          adminInfo?.profilePic
                            ? ImageUrl + "/" + adminInfo?.profilePic
                            : process.env.PUBLIC_URL +
                              "/images/person-circle.svg"
                        }`}
                        alt=""
                        height={24}
                        width={24}
                        className="rounded-circle me-2"
                      />
                      {adminInfo?.firstName+" "+adminInfo?.lastName}
                    </button>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item" to={"/profiledetails"}>
                          Profile
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>{" "}
              {/* / .row */}
            </div>{" "}
            {/* / .header-body */}
          </div>
        </div>
      </div>
    </>}
    </>
  )
}

export default Header
